// extracted by mini-css-extract-plugin
export default {"scroll":"Scroll_scroll__S9P8R","pencil":"Scroll_pencil__lH7Rk"};